import { Injectable } from "@angular/core";
import { CustodiaRemuneradaDataService } from "./custodia-remunerada-data.service";
import { CustodiaRemunerada } from "./model/custodia-remunerada.model";
import { CaronteCustodiaService } from "../caronte-custodia/caronte-custodia.service";
import { catchError, delay, map, Observable, of } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class CustodiaRemuneradaDataMobileService
  implements CustodiaRemuneradaDataService {
  constructor(private caronteCustodiaService: CaronteCustodiaService) { }

  getCustodiaRemunerada(): Observable<CustodiaRemunerada> {
    const relCaronte = "paid-custody";
    return this.caronteCustodiaService.executeRequest(relCaronte).pipe(
      map((res) => {
        return res.data;
      }),
      catchError((e: any) => {
        return of([console.error(e)]).pipe(delay(800));
      })
    );
  }
}
